import { connect } from 'react-redux'
import SellerLookup from './SellerLookup'
import * as flashMessageActions from '../../FlashMessage/FlashMessageActions'
import * as appActions from '../../App/AppActions'

const mapStateToProps = (state) => ({
    apiClientLoaded: state.apiClient.loaded
})

const actions = {
    ...flashMessageActions,
    ...appActions
}

export default connect(mapStateToProps, actions)(SellerLookup)


// WEBPACK FOOTER //
// ./src/components/Seller/Lookup/index.js